import SpriteComponent from '../Component/Render/Sprite';
import * as PIXI from 'pixi.js';
import Game from '../Game';
import TransformComponent from '../Component/Transform';
import GameObject from '../GameObject/GameObject';
import PIXIRenderer from 'System/Render/PIXIRenderer';

type NineSliceProps = {
    texture?: string;
};

export default class NineSlice extends GameObject<PIXI.mesh.NineSlicePlane> {
    protected instantiateContainer(props: NineSliceProps): void {
        this.container = new PIXI.mesh.NineSlicePlane(PIXIRenderer.getTexture(props.texture || 'blank'));
    }

    protected onCreate(props: NineSliceProps): void {
        this.addComponent(TransformComponent);
        this.addComponent(SpriteComponent);
    }
}
